import React from 'react'

export function ExpensesIcon (props) {
  return (
    <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect
        x='1'
        y='5'
        width='22'
        height='14'
        rx='1'
        stroke='currentColor'
        strokeWidth='2'
      />
      <circle cx='12' cy='12' r='3' stroke='currentColor' strokeWidth='2' />
      <path d='M2 9C3.65685 9 5 7.65685 5 6' stroke='currentColor' strokeWidth='2' />
      <path
        d='M22 15C20.3431 15 19 16.3431 19 18'
        stroke='currentColor'
        strokeWidth='2'
      />
      <path d='M19 6C19 7.65685 20.3431 9 22 9' stroke='currentColor' strokeWidth='2' />
      <path d='M5 18C5 16.3431 3.65685 15 2 15' stroke='currentColor' strokeWidth='2' />
    </svg>
  )
}
